// TODO: Move this into a better structure and integrated into
// AnalyticsStore.

import { AnalyticsBrowser } from '@segment/analytics-next';

// we can export this instance to share with rest of our codebase.
export const analytics = AnalyticsBrowser.load({
  writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY || '',
});
